import { isFeatureEnabled } from 'owa-feature-flags';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { lazyInitializeErrorHandlerDevtools } from 'mini-exception-handler-devtools';

export default function initializeErrorHandlerDevtools() {
    if (
        process.env.NODE_ENV === 'dev' ||
        (isFeatureEnabled('fwk-devTools') && isMiniFeatureEnabled('mini-errorpopup'))
    ) {
        // Only enabled for SDF users through feature flag
        lazyInitializeErrorHandlerDevtools.importAndExecute();
    }
}
